export default __webpack_public_path__ + "static/media/sweatermen.e60d9fae.jpg";